module.exports = __webpack_public_path__ + "static/img/9.065a01c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/zh/9.png
// module id = IN8x
// module chunks = 0